import type { PropsWithChildren } from 'react';
import { Link } from '@framework/router/Next/Link';
import { getLeadPathname } from './helpers';
import type { IDealLead } from './types';

interface ILeadLinkProps {
  lead: IDealLead,
  query: string,
  target?: string,
  className?: string,
}

const LeadLink = ({ lead, query, target, className, children }: PropsWithChildren<ILeadLinkProps>) => {
  const pathname = getLeadPathname(lead);

  if (!pathname) {
    return <span>{ children }</span>;
  }

  return (
    <Link
      to={ { pathname, query } }
      className={ className }
      target={ target }
      rel={ target === '_blank' ? 'noopener noreferrer' : undefined }
      stopPropagation
    >
      { children }
    </Link>
  );
};

export default LeadLink;
